import React, { useEffect, useState } from 'react';

function colorForTemp(t) {
  if (t <= 96.6) return '#6fdafaff';
  if (t <= 97.2) return '#b0d3f0ff';
  if (t <= 98.2) return '#92ff7d';
  if (t <= 99.0) return '#f9f871';
  return '#f03e3e';
}

export default function Temperature({ isSleeping }) {
  const MIN = 95.9, MAX = 99.5;
  const BASE = 97.65;
  const SLEEP_DROP = 1;          // instant °F drop when sleeping
  const TICK_MS = 1000;

  const [temp, setTemp] = useState(BASE);

  // Instant reaction to sleep/awake toggle
  useEffect(() => {
    setTemp(isSleeping ? Math.max(MIN, BASE - SLEEP_DROP) : BASE);
  }, [isSleeping]);

  // Always tick; parameters change based on sleep state
  useEffect(() => {
    const id = setInterval(() => {
      setTemp(prev => {
        const target = isSleeping ? (BASE - SLEEP_DROP) : BASE;
        const kReturn = isSleeping ? 0.55 : 0.22;   // stronger pull when sleeping
        const jitter  = isSleeping ? 0.008 : 0.055; // very small sleep jitter

        // mean-reverting random walk toward the current target
        const tsec     = Date.now() / 1000;
        const micro    = isSleeping ? Math.sin(tsec * 0.015) * 0.01 : 0; // ~±0.01°F

        let next = prev
          + (target - prev) * kReturn
          + (Math.random() - 0.5) * jitter
          + micro;

        // occasional tiny hop (still subtle)
        if (!isSleeping && Math.random() > 0.997) {
          next += (Math.random() - 0.5) * 0.08;
        }

        if (next < MIN) next = MIN;
        if (next > MAX) next = MAX;
        return next;
      });
    }, TICK_MS);

    return () => clearInterval(id);
  }, [isSleeping]);

  // === slider math ===
  const norm = (temp - MIN) / (MAX - MIN);
  let posPct = 20 + norm * 80;
  if (isSleeping) posPct = Math.max(10, posPct - 5); // push left instantly

  const color = colorForTemp(temp);

  return (
    <div className="thermometer-row">
      <div
        className="thermometer"
        style={{ boxShadow: `0 0 10px ${color}55, 0 0 20px ${color}35` }}
      >
        <div
          className="slider"
          style={{ left: `${posPct}%`, boxShadow: `0 0 8px ${color}` }}
        />
      </div>
      <div className="temp-readout" style={{ color }}>
        {temp.toFixed(2)}°F
      </div>
    </div>
  );
}
